import React from 'react'

const User = ({name = 'Peacegen Indonesia', className, small, image}) => {
  const size = small ? 24 : 40

  return (
    <div className={`flex items-center ${className}`}>
      <div
        style={{backgroundImage: `url('/images/logos/${image ? image : 'default.svg'}')`, height: `${size}px`, width: `${size}px`, backgroundSize: '60%'}}
        className="bg-no-repeat bg-center bg-white rounded-full mr-2"
      />
      <p className={`text-sm text-gray-444 ${small ? '' : 'font-bold'}`}>{name}</p>
    </div>
  )
}

export { User }